import { useParams } from 'react-router-dom';
import TaskScreen from './TaskScreen';
import ItemViewer from '../components/Common/ItemViewer/ItemViewer';

const DirectoryItemScreen = () => {
  const { slug, id } = useParams();
  if (slug === 'tasks') return <TaskScreen />;
  return <ItemViewer slug={slug} id={id} key={id} />;
};

export default DirectoryItemScreen;
